module.exports = __webpack_public_path__ + "img/lowerleglength.20411ce3.jpeg";